import React, { Component } from 'react';
import _ from 'lodash';
import moment from 'moment';
import StockChart from '../components/stock-chart.js';
import axios from 'axios';


export default class Sector extends Component {

    constructor() {
        super();
        this.state = {
            symbol: 'SPY',
            indices: []
        }
        this.onSymbolSelected = this.onSymbolSelected.bind(this);
    }

    componentDidMount() {

        this.getSectorIndices();
    }

    onSymbolSelected(symbol) {

        this.setState({
            symbol: symbol ? symbol : 'SPY'
        })
    }



    async  getSectorIndices() {

        var sector_symbols = ["SPY", "XLY", "XLP", "XLE", "XLF", "XLV", "XLI", "XLB", "XLRE", "XLK", "XLU", ""]
        let prices = await axios.get('https://api.iextrading.com/1.0/stock/market/batch?types=stats&symbols=' + sector_symbols.join(","));
        if (prices && prices.data) {


            let norm_data = [];
            for (const [key, value] of Object.entries(prices.data)) {

                value.stats.companyName = value.stats.companyName
                    .replace("SPDR Select Sector Fund - ", "")
                    .replace("Select Sector SPDR Fund", '')
                    .replace(" (The)", '')
                    .replace("SPDR ", '');
                norm_data.push(value.stats);
            }

            this.setState({
                indices: norm_data
            });
        }
    }

    render() {

        if (this.state.indices && this.state.indices.length) {

            let onSymbolSelected = this.onSymbolSelected;
            let selectedSymbol = this.state.symbol;
            return (
                <div className="ss-container-stacked ss-page">
                    <nav className="navbar is-transparent ss-fixed-row" style={{ height: "72px", borderBottom: "1px solid #dbdbdb" }}>
                        <div class="navbar-brand">
                            <a class="navbar-item">
                                <img src="https://www.iconexperience.com/_img/g_collection_png/standard/512x512/spreadsheet.png" />
                            </a>
                        </div>
                        <div className="navbar-start">
                            <div className="navbar-item">
                                <div>
                                    <p className="title is-4"><i className="fa fa-industry" style={{ marginRight: "0.75em" }}></i>Sector Health</p>
                                </div>
                            </div>
                        </div>
                    </nav>
                    <section class="section  ss-container-stacked ss-fluid-row" style={{ backgroundColor: "hsl(0, 0%, 96%)" }}>
                        <div className="card ss-fixed-row" >
                            {<StockChart symbol={this.state.symbol} />}
                            <hr style={{ marginTop: "0", backgroundColor: "transparent" }} />
                        </div>
                        <div className="card  ss-fluid-row">

                            <table className="table table is-narrow is-fullwidth table is-hoverable ">
                                <thead>
                                    <th><span className="is-pulled-left">Sector</span></th>
                                    <th><span className="is-pulled-right">5 day</span></th>
                                    <th><span className="is-pulled-right">1 month</span></th>
                                    <th><span className="is-pulled-right">3 month</span></th>
                                    <th><span className="is-pulled-right">YTD</span></th>
                                    <th><span className="is-pulled-right">1 Year</span></th>
                                    <th><span className="is-pulled-right">2 Year</span></th>
                                    <th><span className="is-pulled-right">5 Year</span></th>

                                </thead>
                                <tbody>
                                    {this.state.indices.map(function (indice_item, i) {
                                        return <tr onClick={() => onSymbolSelected(indice_item.symbol)} class={selectedSymbol == indice_item.symbol && "is-selected"}>
                                            <td>{indice_item.companyName}</td>
                                            <td className={indice_item.day5ChangePercent > 0 ? "is-success" : "is-danger"} ><span className="is-pulled-right ">{(indice_item.day5ChangePercent * 100).toFixed(2)} % </span></td>
                                            <td className={indice_item.month1ChangePercent > 0 ? "is-success" : "is-danger"} ><span className="is-pulled-right ">{(indice_item.month1ChangePercent * 100).toFixed(2)} % </span></td>
                                            <td className={indice_item.month3ChangePercent > 0 ? "is-success" : "is-danger"} ><span className="is-pulled-right ">{(indice_item.month3ChangePercent * 100).toFixed(2)} % </span></td>
                                            <td className={indice_item.ytdChangePercent > 0 ? "is-success" : "is-danger"} ><span className="is-pulled-right ">{(indice_item.ytdChangePercent * 100).toFixed(2)} % </span></td>
                                            <td className={indice_item.year1ChangePercent > 0 ? "is-success" : "is-danger"} ><span className="is-pulled-right ">{(indice_item.year1ChangePercent * 100).toFixed(2)} % </span></td>
                                            <td className={indice_item.year2ChangePercent > 0 ? "is-success" : "is-danger"} ><span className="is-pulled-right ">{(indice_item.year2ChangePercent * 100).toFixed(2)} % </span></td>
                                            <td className={indice_item.year5ChangePercent > 0 ? "is-success" : "is-danger"} ><span className="is-pulled-right ">{(indice_item.year5ChangePercent * 100).toFixed(2)} % </span></td>
                                        </tr>



                                    })}
                                </tbody>
                            </table>
                        </div>
                    </section>
                </div>)
        }
        else {
            return <div></div>
        }
    }
}


// WEBPACK FOOTER //
// ./src/containers/sector.js